import React from 'react';

class About extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount() {

  }

  render() {
    return(
      <div className="about">
        <div className="about-holder">
          <img src="/img/about1.jpg" />
          <img src="/img/about2.jpg" />
        </div>

        <div className="about-text">
          <p>Dance to Me is a collaborative experiment in social engagement and viewer interaction created by artists from different disciplines, <a href="http://khariskennedy.com/" target="_blank">Kharis Kennedy</a> and <a href="http://www.carrdancemedia.com/" target="_blank">Bryon Carr</a>. Carr, a dance artist trained in ballet and classical modern dance, choreographed and digitally recorded a 90-second dance piece from his studio in Seattle. In St. Croix, Kennedy, a visual artist with no dance training, then attempted to follow Carr’s movements. During each recording the artists spontaneously responded to the other’s previous 90-second dance phrase, agreeing to be open to the process with no pre-defined expectations other than to stay receptive. Often the dances felt tongue-in-cheek, which unexpectedly became an aspect of the project that brought humor and joy. Through the process the artists shared an intimate experience revealing their personal histories.</p>

          <p>This site invites others to participate in spontaneous, responsive dance. All are invited to join the exchange, bringing their own experiences and cultures. The artists hope this presents and engages a global community, with people worldwide, collaborating as one.</p>
        </div>

      </div>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// src/About.js